import request from '@/utils/request'

/**
* 岗位API
*
* @author Ych Tu
* @since 2023/05/15
*/

/**
* 基础接口
*
* @type {string}
*/
export const BASE_URL = 'system/post'

/**
* 分页查询接口
*
* @type {string}
*/
export const PAGE_URL = `${BASE_URL}/page`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id: any) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}

/**
* 保存数据
*
* @param data 数据
* @returns {Promise}
*/
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
* 更新数据
*
* @param data 数据
* @returns {Promise}
*/
export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
* 删除数据
*
* @param idList ID数组
* @returns {Promise}
*/
export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}


/**
* 查询岗位列表
*
*/
export function list() {
  return request({
    url: `${BASE_URL}/list`,
    method: 'get'
  })
}